<!-- 农机监理 -->
<template>
  <div
    class="vehicle-supervisor"
    style="width: 100%; height: 86vh; display: flex; position: relative"
    id="vehicleSupervisor"
  >
    <!-- <div class="left-part"> -->
    <div class="left-left" id="vehicleSupervisorLeft">
      <div class="item">
        <p class="item-title">农机注册登记(台)</p>
        <p
          class="item-number"
          :data-content="
            numberSeparatorCompute(totalStatistics.vehicleCount || 0)
          "
        >
          {{
            (totalStatistics.vehicleCount || 0).toFixed(0) ||
            0 | toThousandFilter
          }}
        </p>
      </div>
      <div class="item">
        <p class="item-title">农机注销数(台)</p>
        <p
          class="item-number"
          :data-content="
            numberSeparatorCompute(totalStatistics.vehicleCancel || 0)
          "
        >
          {{
            (totalStatistics.vehicleCancel || 0).toFixed(0) ||
            0 | toThousandFilter
          }}
        </p>
      </div>
      <div class="item">
        <p class="item-title">年检数(台)</p>
        <p
          class="item-number"
          :data-content="
            numberSeparatorCompute(totalStatistics.vehicleInspect || 0)
          "
        >
          {{
            (totalStatistics.vehicleInspect || 0).toFixed(0) ||
            0 | toThousandFilter
          }}
        </p>
      </div>
      <div class="item">
        <p class="item-title">农机累计在册(台)</p>
        <p
          class="item-number"
          :data-content="
            numberSeparatorCompute(totalStatistics.vehicleTotal || 0)
          "
        >
          {{
            (totalStatistics.vehicleTotal || 0).toFixed(0) ||
            0 | toThousandFilter
          }}
        </p>
      </div>
      <div class="item part-margin">
        <p class="item-title">满期换证数(人)</p>
        <p
          class="item-number"
          :data-content="
            numberSeparatorCompute(totalStatistics.licenseChange || 0)
          "
        >
          {{
            (totalStatistics.licenseChange || 0).toFixed(0) ||
            0 | toThousandFilter
          }}
        </p>
      </div>
      <div class="item">
        <p class="item-title">增驾数(人)</p>
        <p
          class="item-number"
          :data-content="
            numberSeparatorCompute(totalStatistics.licenseApply || 0)
          "
        >
          {{
            (totalStatistics.licenseApply || 0).toFixed(0) ||
            0 | toThousandFilter
          }}
        </p>
      </div>
      <div class="item">
        <p class="item-title">驾证注销数(人)</p>
        <p
          class="item-number"
          :data-content="
            numberSeparatorCompute(totalStatistics.licenseCancel || 0)
          "
        >
          {{
            (totalStatistics.licenseCancel || 0).toFixed(0) ||
            0 | toThousandFilter
          }}
        </p>
      </div>
      <div class="item">
        <p class="item-title">驾驶员在册数(人)</p>
        <p
          class="item-number"
          :data-content="
            numberSeparatorCompute(totalStatistics.licenseTotal || 0)
          "
        >
          {{
            (totalStatistics.licenseTotal || 0).toFixed(0) ||
            0 | toThousandFilter
          }}
        </p>
      </div>
    </div>
    <div class="select_left">
      <div class="label">统计年份</div>
      <el-select
        size="mini"
        v-model.trim="statisticsYear"
        placeholder=""
        class="work_select year_panel"
      >
        <el-option
          v-for="item in yearOptions"
          :key="item.text"
          :label="item.text"
          :value="item.text"
        ></el-option>
      </el-select>
    </div>
    <div class="left-bottom" id="vehicleSupervisorBottom">
      <div class="left-bottom-first">
        <TitleSlot
          title="历年发放行驶证数量"
          :width="520"
          :contentHeight="175"
          :noHeaderMargin="true"
          :special="true"
        >
          <BottomFirst :chartData="fundTrend"></BottomFirst>
        </TitleSlot>
      </div>

      <div class="left-bottom-second">
        <TitleSlot
          title="各季度农机注册与注销情况统计"
          :width="330"
          :contentHeight="156"
          :noHeaderMargin="true"
          :special="true"
        >
          <!-- <BottomSecond :optionData="pieData" :total="pieTotal"></BottomSecond> -->
          <BottomSecond :chartData="bottomSecondData" v-if="bottomSecondData.length > 0"></BottomSecond>
        </TitleSlot>
      </div>

      <div class="left-bottom-third">
        <div class="age-tabs">
          <div
            @click="driverTab(1)"
            :class="{ 'driver-tab-active': ageTabSelected == 1 }"
          >
            驾龄分布
          </div>
          <div
            @click="driverTab(2)"
            :class="{ 'driver-tab-active': ageTabSelected == 2 }"
          >
            年龄分布
          </div>
          <div
            @click="driverTab(3)"
            :class="{ 'driver-tab-active': ageTabSelected == 3 }"
          >
            性别
          </div>
        </div>
        <TitleSlot
          title="驾驶员画像"
          :width="372"
          :contentHeight="156"
          :noHeaderMargin="true"
          :special="true"
        >
          <BottomThird
            :optionData="driverPieData"
            :type="ageTabSelected"
          ></BottomThird>
        </TitleSlot>
      </div>
    </div>
    <!-- </div> -->

    <div class="right-part">
      <div class="right-part-first-row">
        <div class="right-first-first">
          <TitleSlot
            title="各类型农机在册数"
            titleSuffix="(前十名)"
            :width="296"
            :contentHeight="180"
            backgroundImageSize="header-img-334"
            :noHeaderMargin="true"
            :slotTitleSpecial="true"
          >
            <RightFirst
              id="rightFirstChart"
              :chartData="rightFirstData"
            ></RightFirst>
          </TitleSlot>
        </div>
        <div class="right-first-second">
          <TitleSlot
            title="各类型农机检验数"
            titleSuffix="(前十名)"
            :width="296"
            :contentHeight="180"
            backgroundImageSize="header-img-334"
            :noHeaderMargin="true"
            :slotTitleSpecial="true"
          >
            <RightSecond
              id="rightSecondChart"
              :chartData="rightSecondData"
            ></RightSecond>
          </TitleSlot>
        </div>
      </div>

      <div class="right-second">
        <div class="year-chosed-div">
          <el-select
            v-model.trim="yearValue"
            placeholder=""
            class="use-select"
            popper-class="government-affairs-select-popper use-select"
          >
            <el-option
              v-for="item in yearList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="chart-legend">
          <div></div>
          <span>驾证数量</span>
        </div>
        <TitleSlot
          title="各年度初次申领驾证数量"
          :width="610"
          :contentHeight="127"
          backgroundImageSize="header-img-668"
          :noHeaderMargin="true"
          :slotTitleSpecial="true"
        >
          <RightThird
            id="vehiclesupervisorRightThird"
            :chartData="rightThirdData"
            :max="rightThirdMax"
            :min="rightThirdMin"
          ></RightThird>
        </TitleSlot>
      </div>

      <div class="right-third">
        <div class="chosed-div">
          <el-select
            v-model.trim="driverTypeSelected"
            placeholder=""
            class="month-select"
            popper-class="government-affairs-select-popper"
          >
            <el-option
              v-for="item in driverTypes"
              :key="item.dictLabel"
              :label="item.dictLabel"
              :value="item.dictLabel"
            ></el-option>
          </el-select>
          <el-select
            v-model.trim="quarterSelected"
            placeholder=""
            class="month-select special-select"
            popper-class="government-affairs-select-popper"
          >
            <el-option
              v-for="item in quarterTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <TitleSlot
          title="各类型驾驶证申领数量同环比"
          :width="610"
          :contentHeight="140"
          backgroundImageSize="header-img-668"
          :noHeaderMargin="true"
          :slotTitleSpecial="true"
        >
          <RightFourth
            id="rightFourthChart"
            :chartData="rightFourthData"
            @switchClcik="switchClcik"
          ></RightFourth>
        </TitleSlot>
      </div>

      <div class="right-fourth">
        <div class="chart-legend">
          <div class="chart-legend-item">
            <div class="left-line"></div>
            <span>转入数量</span>
          </div>
          <div class="chart-legend-item">
            <div class="right-line"></div>
            <span>转出数量</span>
          </div>
        </div>
        <TitleSlot
          title="各季度驾证转入/转出数据对比"
          :width="610"
          :contentHeight="143"
          backgroundImageSize="header-img-668"
          :noHeaderMargin="true"
          :slotTitleSpecial="true"
        >
          <RightFifth
            id="rightFifthChart"
            :chartData="rightFifthData"
            :max="rightFifthMax"
            :min="rightFifthMin"
          ></RightFifth>
        </TitleSlot>
      </div>
    </div>

    <ChosePage
      class="chose-page"
      flexDirection="flex-direction: column;"
    ></ChosePage>

    <!-- 地图 -->
    <div class="map_container">
      <MapModel
        ref="mapModel"
        :areaInfoList="areaInfoList"
        :rectBounds="rectBounds"
      />
    </div>
  </div>
</template>

<script>
import * as purchaseAllowanceApi from "@/api/governmentAffairs/purchaseAllowance.js";
import * as vehiclesupervisorApi from "@/api/governmentAffairs/vehiclesupervisor.js";
import { mapGetters } from "vuex";
import TitleSlot from "../components/TitleSlot";
import ChosePage from "../components/ChosePage";
import BottomFirst from "./components/BottomFirst";
import RightFirst from "./components/RightFirst";
import RightSecond from "./components/RightSecond";
import RightThird from "./components/RightThird";
import RightFourth from "./components/RightFourth";
import RightFifth from "./components/RightFifth";
import BottomSecond from "./components/BottomSecond";
import BottomThird from "./components/BottomThird";
import MapModel from "./components/MapModel";

export default {
  components: {
    TitleSlot,
    ChosePage,
    BottomFirst,
    BottomSecond,
    BottomThird,
    RightFirst,
    RightSecond,
    RightThird,
    RightFourth,
    RightFifth,
    MapModel,
  },
  mounted() {
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= 2022; year--) {
      this.yearOptions.push({
        text: year,
      });
    }
    this.$nextTick(() => {
      let centerRectBounds = document
        .getElementById("vehicleSupervisor")
        .getBoundingClientRect();
      this.rectBounds.top = centerRectBounds.top;
      let vehicleSupervisorLeft = document
        .getElementById("vehicleSupervisorLeft")
        .getBoundingClientRect();
      this.rectBounds.left = vehicleSupervisorLeft.right;
      let vehicleSupervisorBottom = document
        .getElementById("vehicleSupervisorBottom")
        .getBoundingClientRect();
      this.rectBounds.bottom = vehicleSupervisorBottom.top;
      let chosePageBoxRectBounds = document
        .getElementById("chosePageBox")
        .getBoundingClientRect();
      this.rectBounds.right = chosePageBoxRectBounds.left;
    });
    this.getCurrentYear();
    this.getDriverTypesSelectOptions();
    if (this.getActiveYear) {
      this.yearValue = this.getActiveYear;
    }
    this.initPageData();
  },
  data() {
    return {
      commonParams: {
        year: new Date().getFullYear(),
      },
      statisticsYear: new Date().getFullYear(),
      yearOptions: [],
      // 顶部8项数据
      totalStatistics: {
        // 农机注册登记(台)
        vehicleCount: 0,
        // 农机注销数(台)
        vehicleCancel: 0,
        // 年检数(台)
        vehicleInspect: 0,
        // 农机累计在册(台)
        vehicleTotal: 0,
        //增驾数(人)
        licenseApply: 0,
        // 驾证注销数(人)
        licenseCancel: 0,
        // 驾驶员在册数(人)
        licenseTotal: 0,
        // 满期换证数(人)
        licenseChange: 0,
      },
      // 历年发放行驶证数量
      fundTrend: [],
      vehicleTimer: null,
      testTimer: null,
      // 各类型农机在册数(前十名)
      rightFirstData: {
        names: [],
        nums: [],
      },
      // 各类型农机检验数(前十名)
      rightSecondData: {
        names: [],
        nums: [],
      },
      // 各年度初次申领驾证数量
      rightThirdData: {
        names: [],
        nums: [],
      },
      // 各年度初次申领驾证数量 (最大值)
      rightThirdMax: 10,
      // 各年度初次申领驾证数量 (最小值)
      rightThirdMin: 0,
      // 各类型驾驶证申领数量同环比
      rightFourthData: {
        yearAndMonth: [],
        years: [],
        months: [],
        dataList: [],
        ratio: 0,
        type: "",
      },
      // 地图弹窗边界
      rectBounds: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      },
      // 驾照类型
      driverTypes: [],
      // 驾照类型(选中)
      driverTypeSelected: "G1",
      // 季度类型(选中)
      quarterSelected: 1,
      // 季度类型
      quarterTypes: [
        {
          value: 1,
          label: "一季度",
        },
        {
          value: 2,
          label: "二季度",
        },
        {
          value: 3,
          label: "三季度",
        },
        {
          value: 4,
          label: "四季度",
        },
      ],
      // 类型  同比1、环比切换2
      ratioType: 1,
      // 年份选中
      yearValue: 2025,
      // 年份
      yearList: [],
      // 各区域驾证转入/转出数据对比
      rightFifthData: {
        list: [
          // {
          //   count: [88,117,123,31,200,199, 165,197,199,6,69,149],
          //   name: "经销商",
          // },
          // {
          //   count: [10,107,103,31,100,199, 135,167,129,6,70,139],
          //   name: "加油站",
          // },
        ],
        labelNames: [],
        // labelNames: ['郑州市,1040', '开封市,813', '洛阳市,1436', '平顶山市,842', '安阳市,868', '鹤壁市,426', '新乡市,1005', '焦作市,862', '濮阳市,635', '许昌市,756', '漯河市,584', '三门峡市,525'],
      },
      // 各区域驾证转入/转出数据对比 （最大值）
      rightFifthMax: 10,
      // 各区域驾证转入/转出数据对比 （最小值）
      rightFifthMin: 0,
      // 累计注销与报废拆解情况统计
      bottomSecondData: [],
      // 累计注销与报废拆解情况统计
      // pieData: [
      //   {
      //     key: "unScrapped",
      //     name: "未报废",
      //     value: 0,
      //   },
      //   {
      //     key: "scrapped",
      //     name: "已报废",
      //     value: 0,
      //   },
      // ],
      // 累计注销与报废拆解情况统计(总数)
      // pieTotal: 0,
      // 驾驶员画像图值
      driverPieData: [],
      // 驾驶员画像是否饼状图值都为0
      isZero: true,
      isZeroObj: {
        profileAge: true,
        driverAge: true,
        driverGender: true,
      },
      ageTimeOut: null,
      // 驾驶员画像接口返回
      driverObj: {},
      // 被选中驾龄、年龄、性别
      ageTabSelected: 0,
      // 驾龄分布
      driverAge: [
        {
          key: "lt3YearsNums",
          name: "小于3年",
          value: 1,
        },
        {
          key: "bt3And10YearsNums",
          name: "3-10年",
          value: 3,
        },
        {
          key: "gt10YearsNums",
          name: "10年以上",
          value: 9,
        },
      ],
      // 年龄分布
      profileAge: [
        {
          key: "bt18And40YearsNums",
          name: "18-40岁",
          value: 3,
        },
        {
          key: "bt41And60YearsNums",
          name: "41-60岁",
          value: 6,
        },
        {
          key: "gt60YearsNums",
          name: "60岁以上",
          value: 8,
        },
      ],
      // 驾驶员性别
      driverGender: [
        {
          key: "male",
          name: "男性",
          value: 3,
        },
        {
          key: "female",
          name: "女性",
          value: 6,
        },
      ],
      // 农机、驾证统计数据(地图使用)
      areaInfoList: [],
    };
  },
  watch: {
    statisticsYear: {
      handler(val) {
        this.commonParams.year = val;
        this.initPageData();
        if (!this.$store.state.activeRegionObj.areaCode) return;
        this.$nextTick(() => {
          if (this.$refs.mapModel) {
            this.$refs.mapModel.addProvince(
              this.$store.state.activeRegionObj.areaCode
            );
          }
        });
      },
    },
    "$store.state.activeRegionObj": {
      deep: true,
      immediate: true,
      handler(val) {
        if (!val.areaCode) return;
        this.isProvinceLevel = val.areaCode == "410000000";
        this.initPageData();
        this.getLastUpdateTime();
        // const city = val.areaCode.slice(0, -3);
        this.$nextTick(() => {
          if (this.$refs.mapModel) {
            this.$refs.mapModel.addProvince(val.areaCode);
          }
        });
      },
    },

    yearValue: {
      handler(val) {
        this.yearValue = val;
        this.getLicenseApplyCountByYear();
      },
    },
    // 季度切换
    quarterSelected: {
      handler(val) {
        this.quarterSelected = val;
        this.getLicenseApplyCountRatio();
      },
    },
    // 驾照类型切换
    driverTypeSelected: {
      handler(val) {
        this.driverTypeSelected = val;
        this.getLicenseApplyCountRatio();
      },
    },
    // 机手、驾龄、性别分布
    ageTabSelected: {
      // immediate: true,
      handler(newVal, oldVal) {
        switch (newVal) {
          case 1:
            this.driverAge = this.driverObj.driving_age || [
              // this.driverAge = null
              {
                type: "driving_age",
                name: "3-10年",
                value: 0,
              },
              {
                type: "driving_age",
                name: "10年以上",
                value: 0,
              },
              {
                type: "driving_age",
                name: "小于3年",
                value: 0,
              },
            ];
            this.isZeroObj.driverAge = this.driverAge.every(
              (item) => item.value == 0
            );
            this.$set(this, "driverPieData", this.driverAge);
            this.$set(this, "isZero", this.isZeroObj.driverAge);
            break;
          case 2:
            this.profileAge = this.driverObj.age || [
              {
                type: "age",
                name: "40-60岁",
                value: 0,
              },
              {
                type: "age",
                name: "60岁以上",
                value: 0,
              },
              {
                type: "age",
                name: "18-40岁",
                value: 0,
              },
            ];
            this.isZeroObj.profileAge = this.profileAge.every(
              (item) => item.value == 0
            );
            this.$set(this, "driverPieData", this.profileAge);
            this.$set(this, "isZero", this.isZeroObj.profileAge);
            break;
          case 3:
            this.driverGender = this.driverObj.gender || [
              {
                type: "gender",
                name: "男",
                value: 0,
              },
              {
                type: "gender",
                name: "女",
                value: 0,
              },
            ];
            this.isZeroObj.driverGender = this.driverGender.every(
              (item) => item.value == 0
            );
            this.$set(this, "driverPieData", this.driverGender);
            this.$set(this, "isZero", this.isZeroObj.driverGender);
            break;
          default:
            break;
        }
        clearTimeout(this.ageTimeOut);
        this.ageTimeOut = setTimeout(() => {
          if (this.ageTabSelected == 1) {
            this.ageTabSelected = 2;
          } else if (this.ageTabSelected == 2) {
            this.ageTabSelected = 3;
          } else if (this.ageTabSelected == 3) {
            this.ageTabSelected = 1;
          }
        }, 5000);
      },
    },
  },
  computed: {
    ...mapGetters(["getActiveYear"]),
    numberSeparatorCompute() {
      return function (number) {
        let regex = /(?!^)(?=(\d{3})+(\.|$))/g;
        if (!number) {
          return 0;
        } else {
          return number.toFixed().replace(regex, ",");
        }
      };
    },
  },
  name: "vehiclesupervisor",
  methods: {
    // 获取驾照类型下拉列表
    getDriverTypesSelectOptions() {
      vehiclesupervisorApi.getDictData("sys_driver_type").then((res) => {
        this.driverTypes = res || [];
      });
    },
    // 驾龄分布、年龄分布、性别选中
    driverTab(index, type) {
      if (index == 1) {
        this.isZero = this.isZeroObj.driverAge;
      }
      if (index == 2) {
        this.isZero = this.isZeroObj.profileAge;
      }
      if (index == 3) {
        this.isZero = this.isZeroObj.driverGender;
      }
      this.ageTabSelected = index;
    },
    // 获取最近5年
    getCurrentYear() {
      let curentYear = new Date().getFullYear();
      for (let i = 0; i < 5; i++) {
        this.yearList.push({
          value: curentYear - i,
          label: curentYear - i + "年",
        });
      }
      this.$store.dispatch("setActiveYear", this.yearList[0].value);
    },
    initPageData() {
      this.getStatistic();
      this.getVehicleTotalCountByType();
      this.getVehicleTestCountByType();
      this.getLicenseApplyCountByYear();
      this.getLicenseApplyCountRatio();
      this.getLicenseInOutCountByArea();
      this.getDriverLicenseTotalCountByYear();
      this.getVehicleCancelCountByYear();
      this.getDriverProfile();
      this.getAreaCountStatistics();
      // this.getLastUpdateTime();
    },
    //获取最后一次跟新时间
    getLastUpdateTime() {
      purchaseAllowanceApi.getLastUpdateTime("JL").then((res) => {
        this.$store.dispatch("setLastUpdateTime", res || "");
      });
    },
    // 仪表盘-各区域年度补贴机具数量统计 (顶部6项数据)
    getStatistic() {
      vehiclesupervisorApi.getStatistic(this.commonParams).then((res) => {
        this.totalStatistics = res;
      });
    },
    // 各类型农机在册数(前十名)
    getVehicleTotalCountByType() {
      vehiclesupervisorApi
        .getVehicleTotalCountByType(this.commonParams)
        .then((res) => {
          let tempArr = Object.assign([], res);
          tempArr.reverse();
          let that = this;
          this.rightFirstData.names = [];
          this.rightFirstData.nums = [];

          // this.rightFirstData.names = ['轮式拖拉机', '轮式联合收割机', '履带式联合收割机', '手扶拖拉机', '轮式联合收割机'];
          // this.rightFirstData.nums = [19074, 13029, 854, 112, 13029];

          if (tempArr && tempArr.length > 0) {
            tempArr.forEach((item) => {
              this.rightFirstData.names.push(item.name);
              this.rightFirstData.nums.push(item.value);
            });
            if (this.rightFirstData.names.length > 5) {
              if (this.vehicleTimer) {
                clearTimeout(this.vehicleTimer);
              }
              this.vehicleTimer = setInterval(function () {
                that.rightFirstData.names.push(
                  that.rightFirstData.names.shift()
                );
                that.rightFirstData.nums.push(that.rightFirstData.nums.shift());
              }, 5000);
            }
          }
        });
    },
    // 各类型农机检验数(前十名)
    getVehicleTestCountByType() {
      vehiclesupervisorApi
        .getVehicleTestCountByType(this.commonParams)
        .then((res) => {
          let tempArr = Object.assign([], res);
          tempArr.reverse();
          let that = this;
          this.rightSecondData.names = [];
          this.rightSecondData.nums = [];

          if (tempArr && tempArr.length > 0) {
            tempArr.forEach((item) => {
              this.rightSecondData.names.push(item.name);
              this.rightSecondData.nums.push(item.value);
            });
            if (this.rightSecondData.names.length > 5) {
              if (this.testTimer) {
                clearTimeout(this.testTimer);
              }
              this.testTimer = setInterval(function () {
                that.rightSecondData.names.push(
                  that.rightSecondData.names.shift()
                );
                that.rightSecondData.nums.push(
                  that.rightSecondData.nums.shift()
                );
              }, 5000);
            }
          }
        });
    },
    // 各年度初次申领驾证数量
    getLicenseApplyCountByYear() {
      let params = {};
      params = Object.assign(params, this.commonParams);
      params.year = this.yearValue;
      vehiclesupervisorApi.getLicenseApplyCountByYear(params).then((res) => {
        let tempArr = Object.assign([], res);
        let max = 10;
        let that = this;
        this.rightThirdData = {
          names: [],
          nums: [],
        };

        tempArr.forEach((item) => {
          this.rightThirdData.names.push(item.name);
          this.rightThirdData.nums.push(item.value);
        });

        max = Math.max(...this.rightThirdData.nums);
        let nums = this.rightThirdData.nums;
        if (max != 0) {
          for (let i = 0; i < nums.length; i++) {
            if (nums[i] == 0) {
              nums[i] = 0.01;
            }
          }
        } else {
          max = 10;
        }
        this.rightThirdMax = Math.round(max * 1.1);

        // if(tempArr && tempArr.length > 0) {
        //   tempArr.forEach(item => {
        //     this.rightThirdData.names.push(item.name);
        //     this.rightThirdData.nums.push(item.value);
        //   })
        //   // if(this.rightSecondData.names.length > 5) {
        //   //   if(this.timer) {
        //   //     clearTimeout(this.timer);
        //   //   }
        //   //   this.timer = setInterval(function () {
        //   //     that.rightSecondData.names.push(that.rightSecondData.names.shift());
        //   //     that.rightSecondData.nums.push(that.rightSecondData.nums.shift());
        //   //   }, 5000);
        //   // }
        // }
      });
    },
    // 年度各月数据同环比 1同比、 2环比
    switchClcik(type) {
      this.ratioType = type;
      this.getLicenseApplyCountRatio();
    },
    // 把季度转为汉字
    getQuarter(quarter) {
      switch (quarter) {
        case 1:
          return "第一季度";
        case 2:
          return "第二季度";
        case 3:
          return "第三季度";
        case 4:
          return "第四季度";
        default:
          return "";
      }
    },
    // 转换数据为所需数据
    turnData(data) {
      if (data) {
        let currentYear = data?.currenYear;
        let currentMonth = this.getQuarter(data?.currenQuarter);
        let passedYear = data?.lastYear;
        let passedMonth = this.getQuarter(data?.lastQuarter);
        this.rightFourthData.yearAndMonth = [
          passedYear + "年" + passedMonth,
          currentYear + "年" + currentMonth,
        ];
        this.rightFourthData.years = [passedYear, currentYear];
        this.rightFourthData.months = [passedMonth, currentMonth];
        this.rightFourthData.dataList = [data.lastCount, data.currenCount];
      }
    },
    // 各类型驾驶证申领数量同环比
    getLicenseApplyCountRatio() {
      let params = {};
      params = Object.assign(params, this.commonParams);
      params.season = this.quarterSelected;
      params.type = this.driverTypeSelected;
      vehiclesupervisorApi.getLicenseApplyCountRatio(params).then((res) => {
        if (!res) {
          return;
        }
        // 同比
        if (this.ratioType == 1) {
          this.turnData(res.yoy);
          this.rightFourthData.ratio = res?.yoy?.ratio;
          this.rightFourthData.type = this.driverTypeSelected;
        } else {
          this.turnData(res.mom);
          this.rightFourthData.ratio = res?.mom?.ratio;
          this.rightFourthData.type = this.driverTypeSelected;
        }
      });
    },
    // 各区域驾证转入/转出数据对比
    getLicenseInOutCountByArea() {
      vehiclesupervisorApi
        .getLicenseInOutCountByArea(this.commonParams)
        .then((res) => {
          if (!res) {
            return;
          }
          let list = [];
          let inObj = {
            count: [],
            name: "转入",
          };
          let outObj = {
            count: [],
            name: "转出",
          };
          let labelNames = [];
          res.forEach((item) => {
            labelNames.push(item.name?.substring(1));
            if (item.in === 0) {
              inObj.count.push(0.1);
            }
            if (item.in != 0) {
              inObj.count.push(item.in);
            }
            if (item.out === 0) {
              outObj.count.push(0.1);
            }
            if (item.out != 0) {
              outObj.count.push(item.out);
            }
          });
          this.rightFifthMax = Math.max(...inObj.count, ...outObj.count);
          if (this.rightFifthMax <= 1) {
            this.rightFifthMax = 10;
          }
          list.push(inObj, outObj);
          this.rightFifthData.list = list;
          this.rightFifthData.labelNames = labelNames;
        });
    },
    // 历年发放行驶证数量
    getDriverLicenseTotalCountByYear() {
      vehiclesupervisorApi
        .getDriverLicenseTotalCountByYear(this.commonParams)
        .then((res) => {
          this.fundTrend = (res || []).reverse();
        });
    },
    //累计注销与报废拆解情况统计
    getVehicleCancelCountByYear() {
      vehiclesupervisorApi
        .getVehicleSeasonStatistic(this.commonParams)
        .then((res) => {
          this.bottomSecondData = res || [];
        });
    },
    // 累计注销与报废拆解情况统计
    // getVehicleCancelCountByYear() {
    //   vehiclesupervisorApi
    //     .getVehicleCancelCountByYear(this.commonParams)
    //     .then((res) => {
    //       this.pieData[0].value = res.unScrapped || 0;
    //       this.pieData[1].value = res.scrapped || 0;
    //       this.pieTotal = res.cancel || 0;
    //     });
    // },
    // 驾驶员画像
    getDriverProfile() {
      vehiclesupervisorApi.getDriverProfile(this.commonParams).then((res) => {
        this.driverObj = res;
        this.ageTabSelected = 1;
      });
    },
    // 农机、驾证统计数据(地图使用)
    getAreaCountStatistics() {
      vehiclesupervisorApi
        .getAreaCountStatistics(this.commonParams)
        .then((res) => {
          this.areaInfoList = res || [];
        });
    },
  },
};
</script>
<style scoped lang="scss">
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

// .left-part {
//   margin-left: vw(24);
//   flex: 1;
//   z-index: 100;

// }
.select_left {
  display: flex;
  position: absolute;
  top: vh(35);
  right: vw(665);
  z-index: 10;
  border-radius: vw(4);
  background-color: #0a441f;
  border: 1px solid #7dab83;
  .label {
    width: vw(72);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: fontSize(14);
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    background-color: #2f7b5f;
    border-top-left-radius: vw(4);
    border-bottom-left-radius: vw(4);
  }
}
::v-deep {
  .year_panel {
    width: vw(84);
    padding: 0;
    .el-input__inner {
      padding: 0 vw(20) 0 vw(18);
      height: vh(28);
      line-height: vh(28);
      text-align: left;
    }
    .el-input__suffix {
      right: vw(10);
    }
  }
}
.vehicle-supervisor {
  margin-top: vh(-35);
  position: relative;
}
.left-left {
  margin-left: vw(35);
  margin-top: vh(20);
  z-index: 99;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: vw(165);
    height: vh(75);
    background-image: url("../../../assets/images/governmentAffairs/vehiclesupervisor/bg_jl_bata.png");
    background-repeat: no-repeat;
    background-size: 100%;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    font-size: fontSize(14);
    color: #effff5;
    .item-title {
      padding-top: vh(4);
      margin-bottom: vh(8);
      // text-align: center;
    }
    .item-number {
      padding: 0 vw(6);
      position: relative;
      font-family: Rajdhani-Bold;
      font-size: fontSize(29);
      color: #fefefe;
      font-style: italic;
      padding-bottom: vh(5);
      // background: linear-gradient(180deg, #FFFFFF 56%, #BDFFCC 60%);
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }
    .item-number::before {
      content: attr(data-content);
      position: absolute;
      top: 0;
      left: vw(6);
      color: transparent;
      text-shadow: 0 0 15px rgba(82, 242, 136, 1); /* 第四层阴影 */
    }
    .item-number::after {
      content: attr(data-content);
      position: absolute;
      top: 0;
      left: vw(6);
      color: transparent;
      background: linear-gradient(180deg, #ffffff 56%, #bdffcc 60%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .part-margin {
    margin-top: vh(18);
  }
}

.left-bottom {
  position: absolute;
  bottom: vh(75);
  left: vw(24);
  z-index: 2;
  display: flex;
  justify-content: space-around;
  .left-bottom-first {
    width: vw(520);
    margin-right: vw(16);
    background: url("../../../assets/images/governmentAffairs/vehiclesupervisor/bg_chart_line.png")
      no-repeat;
    background-position: 83% 89%;
    background-size: 88%;
  }
  .left-bottom-second {
    background: url("../../../assets/images/governmentAffairs/vehiclesupervisor/bg_chart_line_s.png") no-repeat;
    background-position: 88% 79%;
    background-size: 82%;
    .special-body {
      height: vh(220) !important;
    }
    .special-header {
      .slot-title {
        padding-right: 0!important;
      }
    }
  
  }
  .left-bottom-third {
    margin-left: vw(16);
    position: relative;
    .age-tabs {
      position: absolute;
      top: vh(7);
      right: 0;
      display: flex;
      z-index: 3;
      div {
        margin-right: vw(6);
        display: flex;
        justify-content: center;
        width: vw(74);
        height: vh(24);
        line-height: vh(26);
        background-image: url("../../../assets/images/governmentAffairs/vehiclesupervisor/menu_hx.png");
        background-size: 100% 100%;
        font-size: fontSize(14);
        color: #67ce8b;
        cursor: pointer;
      }
      .driver-tab-active {
        color: #ffffff;
        background-image: url("../../../assets/images/governmentAffairs/vehiclesupervisor/menu_hx_c.png");
      }
    }
  }
}

::v-deep.left-bottom {
  .left-bottom-second {
    .special-header {
      .slot-title {
        padding-right: 0!important;
      }
    }
  }
}

.right-part {
  position: absolute;
  top: 0;
  right: vw(18);
  z-index: 100;
  width: vw(615);
  .right-part-first-row {
    display: flex;
    .right-first-first {
      width: vw(296);
      background: url("../../../assets/images/governmentAffairs/vehiclesupervisor/bg_chart_hzz.png")
        no-repeat;
      background-position: 10% 98%;
      background-size: 100%;
    }
    .right-first-second {
      width: vw(296);
      margin-left: vw(18);
      background: url("../../../assets/images/governmentAffairs/vehiclesupervisor/bg_chart_hzz.png")
        no-repeat;
      background-position: 10% 98%;
      background-size: 100%;
    }
  }

  .right-second {
    position: relative;
    background: url("../../../assets/images/governmentAffairs/vehiclesupervisor/bg_chart_zzt.png")
      no-repeat;
    background-position: 90% 91%;
    background-size: 90%;
    .year-chosed-div {
      position: absolute;
      top: vh(22);
      right: vw(20);
    }
    .chart-legend {
      position: absolute;
      top: vh(66);
      right: vw(10);
      font-size: fontSize(12);
      color: #ffffff;
      display: flex;
      align-items: center;
      div {
        width: vw(12);
        height: vh(4);
        background: #26ff72;
        border-radius: 1px;
        margin-right: vw(6);
      }
    }
  }

  .right-third {
    position: relative;
    .chosed-div {
      position: absolute;
      top: vh(24);
      right: vw(26);
      .month-select {
        width: vw(73);
        margin-left: vw(10);
      }
    }
  }

  .right-fourth {
    position: relative;
    background: url("../../../assets/images/governmentAffairs/vehiclesupervisor/bg_chart_zzt.png")
      no-repeat;
    background-position: 86% 92%;
    background-size: 92%;
    .chart-legend {
      position: absolute;
      top: vh(70);
      right: vw(10);
      font-size: fontSize(12);
      color: #ffffff;
      display: flex;
      align-items: center;
      .chart-legend-item {
        display: flex;
        align-items: center;
        margin-left: vw(10);
        .left-line {
          width: vw(12);
          height: vh(4);
          background: #26ff72;
          border-radius: 1px;
          margin-right: vw(6);
        }
        .right-line {
          width: vw(12);
          height: vh(4);
          background: #ffae0d;
          border-radius: 1px;
          margin-right: vw(6);
        }
      }
    }
  }
}

.chose-page {
  position: absolute;
  top: vh(120);
  right: vw(670);
  width: vw(107);
  height: vh(480);
  z-index: 1;
}

.map_container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  background: url("../../../assets/images/governmentAffairs/vehiclesupervisor/bg.gif")
    no-repeat;
  background-size: 100% 100%;
}
</style>
